import React from 'react';
import Popover from '@mui/material/Popover';
import {
  CcfOverflowIcon,
  CcfCollapsePanelIcon,
  CcfNewWindowIcon,
  CcfDraggableIcon,
} from '@nice-ccf/ui-controls';
import { IconButton, Menu, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslator } from '@nice-ccf/ui-controls';
import styles from './ccf-header.module.scss';
import Close from '@mui/icons-material/Close';

export interface CcfHeaderProps {
  children?: React.ReactElement[];
  HeaderWithTab?: React.ReactElement;
  HeaderWithBookmark?: React.ReactElement;
  tabList?: string[];
  headerText?: string;
  headerTextClassess?: string;
  LeftIcon?: React.ReactElement;
  showDragIcon?: boolean;
  RightIcon?: boolean;
  PopoverContent?: React.ReactElement;
  PopoverContentProps?: { dismissable: boolean };
  direction?: 'ltr' | 'rtl';
  isNewWindowIcon?: boolean;
  isAppSpaceHeaderVisible?: boolean;
}

const useStyles = makeStyles((theme) => ({
  customRootClass: {
    '&.MuiIconButton-root': { padding: '0px' },
  },
}));

/**
 *
 * @param headerText - Text to be displayed inside the Header Title
 * @param RightIcon - Icon to be displayed in the left side of the Header
 * @param PopoverContent - Content to be displayed inside the
 * @param headerTextClassess - Classes to be applied on the Header Text
 * @example <CCfHeader />
 * @returns CcfHeader Component
 */
export function CcfHeader({
  children,
  headerText,
  HeaderWithTab,
  HeaderWithBookmark,
  tabList,
  LeftIcon,
  showDragIcon,
  RightIcon,
  PopoverContent,
  PopoverContentProps,
  headerTextClassess,
  direction,
  isNewWindowIcon,
  isAppSpaceHeaderVisible,
  ...rest
}: CcfHeaderProps) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  /**
   *
   * @param event - any
   * @example handleClick(event)
   */
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Function to handle close
   * @example handleClose()
   */
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const classes = useStyles();
  const [translate] = useTranslator();

  return (
    <>
      <section
        id="agent_interactionWorkspace_headerContainer"
        className={`${styles.headerContainer} ${
          HeaderWithTab ? styles.headerTabBackground : ''
        }`}
      >
        <div
          style={{
            display:
              typeof isAppSpaceHeaderVisible === 'undefined' ||
              isAppSpaceHeaderVisible
                ? 'flex'
                : 'none',
          }}
        >
          {showDragIcon ? (
            <CcfDraggableIcon className={styles.dragIndicator} />
          ) : (
            <span style={{ marginLeft: '8px' }}></span>
          )}
          {LeftIcon !== undefined ? LeftIcon : null}
          {HeaderWithTab ? (
            HeaderWithTab
          ) : (
            <label
              className={`${styles.headerLabel} ${headerTextClassess}`}
              id={`agent_interactionWorkspace_name_${headerText}`}
            >
              {headerText}
            </label>
          )}
        </div>
        {RightIcon ? (
          <div>
            <div className={styles['popOver']}>
              <div onClick={handleClick}>
                <IconButton
                  aria-controls="callControlDialog"
                  aria-haspopup="true"
                  onClick={handleClick}
                  classes={{
                    root: classes.customRootClass,
                  }}
                  className="popOverOverflow"
                >
                  <CcfOverflowIcon />
                </IconButton>
              </div>
              {PopoverContent !== undefined ? (
                <Popover
                  id={id}
                  open={open}
                  keepMounted
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  {PopoverContentProps?.dismissable && (
                    <IconButton
                      onClick={handleClose}
                      size="small"
                      classes={{ sizeSmall: styles.popOverDismissButton }}
                    >
                      <Close
                        classes={{ root: styles.popOverDismissButtonIcon }}
                      />
                    </IconButton>
                  )}
                  {PopoverContent}
                </Popover>
              ) : (
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  classes={{
                    paper:
                      direction === 'rtl'
                        ? styles.rtlPopoverMenu
                        : styles.popoverMenu,
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem
                    onClick={handleClose}
                    classes={{
                      root: styles.menuItem,
                    }}
                  >
                    <CcfCollapsePanelIcon
                      classes={{
                        root: styles.minimizePanelIcon,
                      }}
                    />{' '}
                    <span className={styles.minimizePanelLabel}>
                      {' '}
                      {translate('minimizePanel')}
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={handleClose}
                    classes={{
                      root: styles.menuItem,
                    }}
                  >
                    <CcfNewWindowIcon
                      classes={{
                        root: styles.browserWindowIcon,
                      }}
                    />{' '}
                    <span className={styles.browserLabel}>
                      {' '}
                      {translate('newBrowserWindow')}
                    </span>
                  </MenuItem>
                </Menu>
              )}
            </div>
          </div>
        ) : isNewWindowIcon ? (
          <CcfNewWindowIcon
            classes={{
              root: styles.browserWindowIcon,
            }}
          />
        ) : null}
      </section>
      <div>{HeaderWithBookmark}</div>
    </>
  );
}

CcfHeader.defaultProps = {
  headerTextClassess: '',
};

export default CcfHeader;
